import React from 'react';
import { motion } from 'framer-motion';
import './Portfolio.css';
import { portfolioData } from '../../data/portfolioData';
import { FaGithub, FaGlobe, FaApple, FaGooglePlay } from 'react-icons/fa';

const Portfolio = () => {
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.12, delayChildren: 0.1 }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 56 },
    show: {
      opacity: 1,
      y: 0,
      transition: { type: 'spring', stiffness: 200, damping: 24 }
    }
  };

  const spring = { type: 'spring', stiffness: 320, damping: 24 };

  const getLinks = (links) => {
    const buttons = [];
    if (links?.website) {
      buttons.push({ href: links.website, label: 'Website', Icon: FaGlobe });
    }
    if (links?.playStore) {
      buttons.push({ href: links.playStore, label: 'Play Store', Icon: FaGooglePlay });
    }
    if (links?.appStore) {
      buttons.push({ href: links.appStore, label: 'App Store', Icon: FaApple });
    }
    if (links?.github) {
      buttons.push({ href: links.github, label: 'GitHub', Icon: FaGithub });
    }
    return buttons;
  };

  return (
    <section id={portfolioData.header.id} className="portfolio-section">
      <motion.h5
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        {portfolioData.header.subtitle}
      </motion.h5>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.08 }}
      >
        {portfolioData.header.title}
      </motion.h2>

      <div className="container portfolioContainer">
        <motion.div
          className="portfolioGrid"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: '-50px' }}
        >
          {portfolioData.items.map((project, index) => {
            const linkButtons = getLinks(project.links);
            return (
              <motion.div
                key={project.id}
                className="portfolioItem"
                variants={item}
                whileHover={{
                  y: -14,
                  scale: 1.03,
                  transition: spring
                }}
                whileTap={{ scale: 0.98 }}
              >
                <motion.div
                  className="portfolioItemImg"
                  whileHover={{ scale: 1.05 }}
                  transition={spring}
                >
                  <img src={project.image} alt={project.title} />
                  <div className="portfolioItemOverlay" />
                </motion.div>
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="portfolioCta">
                  {linkButtons.length > 0 ? (
                    linkButtons.map((btn, i) => (
                      <motion.a
                        key={i}
                        href={btn.href}
                        rel="noreferrer"
                        target="_blank"
                        className={i === 0 ? 'btn btn-primary' : 'btn'}
                        whileHover={{ y: -2, scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        transition={spring}
                      >
                        <btn.Icon /> {btn.label}
                      </motion.a>
                    ))
                  ) : (
                    <span className="portfolioNoLinks">Coming soon</span>
                  )}
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default Portfolio;
